import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DataTable, Dialog, IconButton, Loader } from '@clatter/ui';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AdminContentHead from '../AdminContentHead';
import {
  deleteVideoCategory,
  fetchVideoCategories,
  selectAllVideoCategories,
} from '../../../store/video-categories.slice';
import { formatDate } from '../../../helpers';
import VideoCategoryForm from './VideoCategoryForm';

const videoCategoryColumns = [
  {
    label: 'Category name',
    name: 'categoryName',
    align: 'left',
    sortable: true,
  },
  {
    label: 'Date added',
    name: 'createdAt',
    customRender: (row) => formatDate(row.createdAt, true),
    align: 'left',
    sortable: true,
  },
];

const VideoCategories = () => {
  const dispatch = useDispatch();
  const [editableItem, setEditableItem] = useState(null);

  useEffect(() => {
    dispatch(fetchVideoCategories());
  }, [dispatch]);

  const videoCategories = useSelector(selectAllVideoCategories);

  const loading = useSelector(
    (state) => state.videoCategories.loadingStatus === 'loading',
  );

  const handleEditClick = (event) => {
    const clickedItemId = event.currentTarget?.dataset?.id;

    setEditableItem(
      (clickedItemId &&
        videoCategories.find(
          (videoCategory) => videoCategory.id === clickedItemId,
        )) ||
        {},
    );
  };

  const handleDismissEdit = () => {
    setEditableItem(null);
  };

  const handleDeleteClick = (event) => {
    if (window.confirm('Are you sure you want to remove this category?')) {
      dispatch(deleteVideoCategory(event.currentTarget.dataset.id));
    }
  };

  const isEdit = editableItem && 'categoryName' in editableItem;

  return (
    <>
      {loading && <Loader />}
      <AdminContentHead>
        <h1>Video embeds</h1>
        <Button onClick={handleEditClick}>Add category</Button>
      </AdminContentHead>
      <div>
        <DataTable
          autofit
          columns={videoCategoryColumns}
          defaultSortField="categoryName"
          filterColumns={['categoryName']}
          name="adminVideoCategories"
          rows={videoCategories}
          renderActionColumn={(row) => (
            <>
              <IconButton data-id={row.id} onClick={handleEditClick}>
                <EditOutlinedIcon />
              </IconButton>
              <IconButton data-id={row.id} onClick={handleDeleteClick}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </>
          )}
        />
      </div>
      <Dialog
        title={isEdit ? 'Edit video category' : 'Add video category'}
        onCloseDialog={handleDismissEdit}
        open={!!editableItem}
      >
        <VideoCategoryForm
          isEdit={isEdit}
          editableItem={editableItem}
          onSuccess={handleDismissEdit}
        />
      </Dialog>
    </>
  );
};

export default VideoCategories;
